import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContentService } from '../services/content.service';
import { AppConfigProvider } from '../../../app-config.provider';

@Injectable({ providedIn: 'root' })
export class ContentFactory {
  private readonly baseUrl: string;

  constructor(private readonly httpClient: HttpClient, private readonly appConfigProvider: AppConfigProvider) {
    this.baseUrl = appConfigProvider.getContentBaseUrl();

  }
  getContentService(schemaName: string): ContentService {
    return new ContentService(this.httpClient, this.baseUrl, schemaName, this.appConfigProvider);
  }
}
